import React from 'react';
import PropTypes from 'prop-types';
import Editpopup from '../articlecontent/Editpopup';
import SearchIcon from '@material-ui/icons/Search';
import { InputBase, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel,Paper } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";

function createData(resourceid, title, categorytag, topictag,key) {
  return { resourceid, title, categorytag, topictag,key};
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {props.headCells.map((headCell) => (
          <TableCell key={headCell.id} align={'left'} padding={headCell.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === headCell.id ? order : false} className={classes.tableStyle} >
            <TableSortLabel active={orderBy === headCell.id} direction={orderBy === headCell.id ? order : 'asc'}
            onClick={createSortHandler(headCell.id)} >
              {headCell.label}
              {orderBy === headCell.id ? ( <span className={classes.visuallyHidden}> </span> ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth:'1200px', padding:0, margin:'0 auto'
  },
  pagination:{
    backgroundColor:'rgb(243, 244, 245)'
  },
  paddingleft20:{paddingLeft:'30px'},
  paper: {width: '100%', boxShadow:'none' },
  title: {flex: '1 1 100%', padding: "34px", paddingLeft:'15px', fontSize: "40px", color: "black", lineHeight: ".78px"},
button: {height: "40px", margin: "20px 0", marginRight: "20px", backgroundColor: "#2262bf", textColor: "#fff", color: "white",paddingTop: "7px",
paddingRight: "26px", paddingLeft: "13px", paddingBottom: "7px", fontSize: "13.7px", whiteSpace: "nowrap",cursor: "pointer",
borderRadius: "50px", [theme.breakpoints.down("sm")]: { fontSize: '12px', minWidth: "120px" }, '&:hover': { backgroundColor: "green", color: '#FFF' }},
  table: {minWidth: 500,},
  tableWrapper: {overflowX: 'auto',},
  tableStyle: { color:'rgba(115, 115, 115, 1)', backgroundColor: "rgb(243, 244, 245)", fontSize: "14px", fontFamily: "roboto", fontWeight: 800,},
  search: {position: 'relative', borderRadius: theme.shape.borderRadius, '&:hover': { backgroundColor: "white" }, backgroundColor: "white",
marginBottom: "5px", marginLeft: 0, width: '100%', [theme.breakpoints.up('sm')]: { width: '100%', },},
searchbackground:{backgroundColor:'rgb(236, 237, 237)', padding:'10px', paddingBottom:'5px', width:'100%'},
  searchIcon: {padding: theme.spacing(1.5, 2), height: '100%', position: 'absolute', pointerEvents: 'none', display: 'flex', justifyContent: 'center', alignItems:'center'},
  inputRoot: {color: 'inherit', width:'100%'},
  inputInput: {padding: theme.spacing(1, 1, 1, 0), paddingLeft: `calc(1em + ${theme.spacing(4)}px)`, transition: theme.transitions.create('width'), width: '100%',
 height:'30px', [theme.breakpoints.up('sm')]: { width: '20ch', '&:focus': { width: '35ch', }, },},
  viewButtonLabel: { padding:'30px', paddingLeft: "36px" },
  image:{width:"60px",height:"40px",borderRadius:"5%"
}}));

function EnhancedTable(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('title');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
 const noofrow=[10, 20, 30];
const [value, setValue] = React.useState('');
 const orginalrows = [];
  if (props.name === 'category') {
    props.articletemplate.map((val) => {
      return orginalrows.push(createData(val.categoryid, val.title, val.image));
    });
  }
  if (props.name === 'topic') {
    props.articletemplate.map((val) => {
      return orginalrows.push(createData(val.topicid, val.title, val.image));
    });
  }
const rows = value ?(props.name==='topic'||props.name==='category')?
orginalrows.filter((n)=>n.resourceid=== +value): orginalrows:orginalrows;

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (resourceid) => selected.indexOf(resourceid) !== -1;
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
 <div className={classes.searchbackground}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon/>
            </div>
            <InputBase placeholder={props.placeholder}
              onChange={handleChange} value={value} classes={{ root: classes.inputRoot, input: classes.inputInput, }}
              inputProps={{ 'aria-label': 'search' }} />
            </div>
          </div>
      <br/>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" size={'medium'} aria-label="enhanced table" >
            <EnhancedTableHead classes={classes} numSelected={selected.length} order={order} orderBy={orderBy}
            onRequestSort={handleRequestSort} rowCount={rows.length} headCells={props.headCells} />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.resourceid);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow aria-checked={isItemSelected} tabIndex={-1} key={row.resourceid} selected={isItemSelected} >
                      <TableCell id={labelId} scope="row" align="left"> {row.resourceid} </TableCell>
                      <TableCell align="left" className={classes.paddingleft20} >{row.title}</TableCell>
                      {(props.name==='topic'||props.name==='category')? <TableCell align="right">  <Avatar alt="Remy Sharp" src={row.img}  className={classes.image}/></TableCell>
                      : <TableCell align="left" className={classes.paddingleft20}>{row.categorytag}</TableCell>}
                      <TableCell align="left" className={classes.paddingleft20}>{row.topictag}</TableCell>
                      <TableCell align="left"> <Editpopup resourceid={row.resourceid} handleEditUser={props.handleEditTrivia}
                       handleDeleteUser={props.handleDeleteUser} name={props.name} /></TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination rowsPerPageOptions={noofrow} component="div" count={rows.length} rowsPerPage={rowsPerPage} page={page} onChangePage={handleChangePage} onChangeRowsPerPage={handleChangeRowsPerPage} className={classes.pagination} />
      </Paper>
    </div>
  );
}
export default (AuthenticatedPage()(EnhancedTable));
